/* duuree-share.js — share dialog for the product page and the cart on duuree.com (Horizon), 2026-11-02.
   Ported from designlight's dl-share.js (dialog) and the cart-share-permalink "simple variant"
   (ua-core pattern): the cart link is a /cart/clear → /cart/add chain that carries quantities,
   selling plans (pre-orders) and visible line properties; it REPLACES the recipient's cart.
   The product link is built, not copied: origin + locale root + products/<handle> (+ ?variant=),
   so utm, fbclid and preview_theme_id never travel.
   Texts come from Liquid (snippets/duuree-share.liquid writes them into [data-dus-strings]).
   QR: assets/duuree-qr.js (global `qrcode`) loads on the first open from data-dus-qr.
   Buttons: any element with data-dus-share="product" or data-dus-share="cart". Delegated on
   document, so Horizon's section morphs (variant change, cart updates) never lose the handler. */
(function () {
  'use strict';
  if (window.__dusInit) return;
  window.__dusInit = true;

  var SHARE_MAX = 7000;   /* chars: past this the server refuses the link (8 kB limit, measured) */
  var QR_DENSE = 1200;    /* bytes: dense code, hint to come closer / AirDrop */
  var QR_MAX = 2953;      /* bytes: QR version 40, level L, byte mode */

  var SHARE_IC = '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><circle cx="6" cy="12" r="2.5"></circle><circle cx="18" cy="6" r="2.5"></circle><circle cx="18" cy="18" r="2.5"></circle><path d="m8.2 10.8 7.6-3.6M8.2 13.2l7.6 3.6"></path></svg>';
  var COPY_IC = '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="9" width="11" height="11"></rect><path d="M5 15V5a1 1 0 0 1 1-1h9"></path></svg>';
  var TICK_IC = '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="m5 13 4.5 4.5L19 7"></path></svg>';
  var X_IC = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  var FALLBACK = {
    eyebrow: 'Sdílet', product_title: 'Sdílet produkt', cart_title: 'Váš košík',
    product_note: 'Odkaz otevře tento produkt. Košík příjemce se nezmění.',
    cart_note: 'Odkaz sestaví celý tento košík. Pozor: příjemci nahradí jeho stávající košík.',
    cart_empty: 'Košík je prázdný, zatím není co sdílet.',
    cart_too_long: 'Tento košík je na jeden odkaz příliš velký. Odeberte pár položek a zkuste to znovu.',
    copy: 'Kopírovat odkaz', copied: 'Zkopírováno', copy_failed: 'Zkopírujte ručně',
    native: 'AirDrop, Zprávy…', close: 'Zavřít', link: 'Odkaz', qr_label: 'QR kód odkazu',
    qr_dense: 'Velký košík, hustý kód: přibližte telefon, nebo pošlete odkaz přes AirDrop.',
    qr_too_long: 'Odkaz je na QR kód příliš dlouhý. Pošlete ho přes AirDrop, nebo ho zkopírujte.'
  };

  function strings() {
    var el = document.querySelector('[data-dus-strings]');
    var s = {};
    try { s = el ? JSON.parse(el.textContent) : {}; } catch (e) { s = {}; }
    var out = {};
    var ta = document.createElement('textarea');
    for (var k in FALLBACK) {
      var v = s[k] || FALLBACK[k];
      // the Liquid `t` filter HTML-escapes its output (&#39; …); the dialog sets textContent, so decode once
      if (v.indexOf('&') !== -1) { ta.innerHTML = v; v = ta.value; }
      out[k] = v;
    }
    return out;
  }

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  /* ---------- links ---------- */

  function buildCartLink(cart) {
    var p = new URLSearchParams();
    cart.items.forEach(function (item) {
      p.append('items[][id]', String(item.variant_id || item.id));
      p.append('items[][quantity]', String(item.quantity));
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        p.append('items[][selling_plan]', String(item.selling_plan_allocation.selling_plan.id));
      }
      Object.keys(item.properties || {}).forEach(function (key) {
        if (key.charAt(0) === '_') return;
        var v = item.properties[key];
        if (v === null || v === undefined || v === '') return;
        p.append('items[][properties][' + key + ']', String(v));
      });
    });
    p.append('return_to', root() + 'cart');
    var add = root() + 'cart/add?' + p.toString();
    return location.origin + root() + 'cart/clear?return_to=' + encodeURIComponent(add);
  }

  function productLink(btn) {
    var ids = (btn.getAttribute('data-variants') || '').split(',').filter(Boolean);
    var candidates = [];
    var scope = btn.closest('.shopify-section') || document;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (el) { candidates.push(el.value); });
    candidates.push(new URLSearchParams(location.search).get('variant'));
    var variant = candidates.filter(function (v) { return v && ids.indexOf(String(v)) > -1; })[0];
    return location.origin + root() + 'products/' + encodeURIComponent(btn.getAttribute('data-handle') || '') +
      (variant && ids.length > 1 ? '?variant=' + variant : '');
  }

  /* ---------- copy ---------- */

  function legacyCopy(input) {
    input.focus(); input.select();
    try { input.setSelectionRange(0, input.value.length); } catch (e) {}
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    return ok;
  }

  function copyText(text, input) {
    return new Promise(function (resolve) {
      if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(function () { resolve(true); }, function () { resolve(legacyCopy(input)); });
      } else {
        resolve(legacyCopy(input));
      }
    });
  }

  /* ---------- QR ---------- */

  var qrLoad = null;
  function loadQr() {
    if (window.qrcode) return Promise.resolve();
    if (!qrLoad) {
      var el = document.querySelector('[data-dus-qr]');
      if (!el) return Promise.reject(new Error('no qr src'));
      qrLoad = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = el.getAttribute('data-dus-qr');
        s.async = true;
        s.onload = function () { window.qrcode ? resolve() : reject(new Error('no qrcode')); };
        s.onerror = reject;
        document.head.appendChild(s);
      }).catch(function (err) { qrLoad = null; throw err; });
    }
    return qrLoad;
  }

  function qrSvg(data, label) {
    var q = window.qrcode(0, 'L');
    q.addData(data);
    q.make();
    var n = q.getModuleCount(), w = n + 8, d = '';
    for (var r = 0; r < n; r++) {
      for (var c = 0; c < n; c++) {
        if (!q.isDark(r, c)) continue;
        var s = c;
        while (c + 1 < n && q.isDark(r, c + 1)) c++;
        d += 'M' + s + ' ' + r + 'h' + (c - s + 1) + 'v1h-' + (c - s + 1) + 'z';
      }
    }
    return '<svg viewBox="-4 -4 ' + w + ' ' + w + '" shape-rendering="crispEdges" role="img" aria-label="' + label + '">' +
      '<rect x="-4" y="-4" width="' + w + '" height="' + w + '" fill="#fff"></rect><path d="' + d + '" fill="#000"></path></svg>';
  }

  var qrSeq = 0;
  function drawQr(d, url, T) {
    var fig = d.querySelector('.dus-qr'), code = d.querySelector('.dus-qr-code'), hint = d.querySelector('.dus-qr-hint');
    var seq = ++qrSeq;
    fig.hidden = true; code.innerHTML = ''; hint.hidden = true; d.classList.remove('has-qr');
    if (!url) return;
    var data = url.replace(/[^\x00-\x7f]+/g, encodeURIComponent);
    var say = function (txt) { hint.textContent = txt; hint.hidden = false; fig.hidden = false; };
    if (data.length > QR_MAX) { say(T.qr_too_long); return; }
    loadQr().then(function () {
      if (seq !== qrSeq) return;
      try { code.innerHTML = qrSvg(data, T.qr_label); } catch (e) { say(T.qr_too_long); return; }
      fig.hidden = false;
      d.classList.add('has-qr');
      if (data.length > QR_DENSE) say(T.qr_dense);
    }).catch(function () { /* no code; the link and buttons still work */ });
  }

  /* ---------- dialog ---------- */

  var dialog = null, current = { url: '', title: '' };

  function build(T) {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'dus-dialog';
    dialog.setAttribute('aria-label', T.eyebrow);
    dialog.innerHTML =
      '<div class="dus-panel">' +
        '<button type="button" class="dus-x" aria-label="' + T.close + '">' + X_IC + '</button>' +
        '<div class="dus-main">' +
          '<span class="dus-eyebrow">' + T.eyebrow + '</span>' +
          '<h2 class="dus-title"></h2>' +
          '<p class="dus-note"></p>' +
          '<input class="dus-url" type="text" readonly aria-label="' + T.link + '">' +
          '<div class="dus-actions">' +
            '<button type="button" class="dus-btn" data-dus-copy>' + COPY_IC + '<span>' + T.copy + '</span></button>' +
            (navigator.share ? '<button type="button" class="dus-btn dus-btn--ghost" data-dus-native>' + SHARE_IC + '<span>' + T.native + '</span></button>' : '') +
          '</div>' +
          '<p class="dus-msg" role="status" aria-live="polite" hidden></p>' +
        '</div>' +
        '<figure class="dus-qr" hidden><span class="dus-qr-code"></span><p class="dus-qr-hint" hidden></p></figure>' +
      '</div>';
    document.body.appendChild(dialog);

    dialog.querySelector('.dus-x').addEventListener('click', function () { dialog.close(); });
    /* a tap on the backdrop (outside the panel) closes it */
    dialog.addEventListener('click', function (e) { if (!e.target.closest('.dus-panel')) dialog.close(); });
    var input = dialog.querySelector('.dus-url');
    input.addEventListener('focus', function () { input.select(); input.scrollLeft = 0; });

    var copy = dialog.querySelector('[data-dus-copy]'), revert = 0;
    copy.addEventListener('click', function () {
      clearTimeout(revert);
      copyText(current.url, input).then(function (ok) {
        copy.classList.remove('ok', 'err');
        copy.classList.add(ok ? 'ok' : 'err');
        copy.innerHTML = (ok ? TICK_IC : COPY_IC) + '<span>' + (ok ? T.copied : T.copy_failed) + '</span>';
        if (!ok) { input.focus(); input.select(); }
        revert = setTimeout(function () {
          copy.classList.remove('ok', 'err');
          copy.innerHTML = COPY_IC + '<span>' + T.copy + '</span>';
        }, 2000);
      });
    });

    var nat = dialog.querySelector('[data-dus-native]');
    if (nat) nat.addEventListener('click', function () {
      /* cancelling the sheet rejects: not an error, the dialog just stays */
      navigator.share({ title: current.title, url: current.url }).then(function () { dialog.close(); }, function () {});
    });
    return dialog;
  }

  /* o = { url, title, note, msg } — an empty url shows only msg */
  function open(o) {
    var T = strings();
    var d = build(T);
    var url = o.url || '';
    current = { url: url, title: o.title || document.title };
    d.querySelector('.dus-title').textContent = o.title || '';
    d.querySelector('.dus-note').textContent = o.note || '';
    var input = d.querySelector('.dus-url');
    input.value = url;
    input.hidden = !url;
    d.querySelector('.dus-actions').hidden = !url;
    var msg = d.querySelector('.dus-msg');
    msg.textContent = o.msg || '';
    msg.hidden = !o.msg;
    drawQr(d, url, T);
    if (!d.open) { if (d.showModal) d.showModal(); else d.setAttribute('open', ''); }
    setTimeout(function () { if (url) { try { input.focus(); input.select(); input.scrollLeft = 0; } catch (e) {} } }, 60);
  }

  function openCart(btn) {
    var T = strings();
    btn.setAttribute('aria-busy', 'true');
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var url = '', msg = '';
        if (!cart.items || !cart.items.length) msg = T.cart_empty;
        else {
          url = buildCartLink(cart);
          if (url.length > SHARE_MAX) { url = ''; msg = T.cart_too_long; }
        }
        open({ url: url, msg: msg, title: T.cart_title, note: url ? T.cart_note : '' });
      })
      .catch(function () { open({ url: '', title: T.cart_title, msg: T.copy_failed }); })
      .then(function () { btn.removeAttribute('aria-busy'); });
  }

  function openProduct(btn) {
    var T = strings();
    open({ url: productLink(btn), title: btn.getAttribute('data-title') || T.product_title, note: T.product_note });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-dus-share]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('data-dus-share') === 'product') openProduct(btn); else openCart(btn);
  });

  window.DuureeShare = { open: open };
})();
